// Deps
import request from 'utils/request'
//import store from 'store'

// Actions
//import { setData, setInitialized, setRefreshToken, setAccessToken, setAccountCode } from 'store/user/actions'

const reportServices = {
	getExpressReports: (params) => {
		return new Promise((resolve, reject) => {
			//let userState = store.getState()['user'];
			request.post(
				'get-express-reports',
				params,
				(payload, status, request) => {
					if(status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	getCostReports: (params) => {
		return new Promise((resolve, reject) => {
			request.post(
				'list-cost-reports',
				params,
				(payload, status, request) => {
					if (status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	getBalanceStatusReports: (params) => {
		return new Promise((resolve, reject) => {
			request.post(
				'list-balance-status-reports',
				params,
				(payload, status, request) => {
					if(status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	getPaymentGraphics: (params) => {
		return new Promise((resolve, reject) => {
			request.post(
				'get-char-reports',
				params,
				(payload, status, request) => {
					if(status === 200 && payload) {
						resolve(payload);
					}
					else {
						reject(false);
					}
				}
			);
		});
	},
	
}

export default reportServices;